import React from "react";
import {Row} from "react-bootstrap";
import {CheckboxGroup, RadioGroup, Textarea} from "../../../genericComponents";
import {contactNames} from "../models/formArrayNames";

const EDUCATION_OPTIONS = [
  "Analfabeto(a)",
  "Ensino Fundamental Completo",
  "Ensino Fundamental Incompleto",
  "Ensino Médio Completo",
  "Ensino Médio Incompleto",
  "Ensino Superior Completo",
  "Ensino Superior Incompleto",
];

/**
 * Escolaridade, contato e observações — dados do cliente (tabela customer), não do questionário.
 * Ficavam no formulário do questionário antigo.
 */
function BasicData8({disabled}) {
  return (
    <>
      <Row>
        <RadioGroup
          label="Escolaridade?"
          name="education"
          options={EDUCATION_OPTIONS.map((value) => ({value, label: value}))}
          required='O campo "Escolaridade?" é obrigatório.'
          disabled={disabled}
          inline
        />
      </Row>
      <Row>
        <CheckboxGroup
          name="contactWay"
          label="Quais os métodos preferenciais para entrarmos em contato?"
          disabled={disabled}
          options={contactNames.map((name) => ({label: name, value: name, checked: true}))}
        />
      </Row>
      <Row>
        <RadioGroup
          name="receiveNotification"
          label="Que tal receber notificações sobre o andamento do seu processo?"
          disabled={disabled}
          options={[{label: "Sim", value: "Sim"}, {label: "Não", value: "Não"}]}
          inline
        />
      </Row>
      <Row>
        <Textarea
          label="Se você quiser inserir alguma informação adicional que possa orientar nossos consultores:"
          name="additionalInformation"
          disabled={disabled}
          maxLength={1000}
        />
      </Row>
    </>
  );
}

export default React.memo(BasicData8);
